export const navlink = [
    {
        id: 1,
        navTitle: "home",
        navlink: "#home",
        navClicked: false,
    },
    {
        id: 2,
        navTitle: "about",
        navlink: "#about",
        navClicked: false,
    },
    {
        id: 3,
        navTitle: "qualification",
        navlink: "#qualification",
        navClicked: false,
    },
    {
        id: 4,
        navTitle: "services",
        navlink: "#services",
        navClicked: false,
    },
    {
        id: 5,
        navTitle: "portfolio",
        navlink: "#portfolio",
        navClicked: false,
    },
];

export const categories = [
    "All",
    "HTML CSS JavaScript",
    "React",
    "Squarespace",
];

export const projects = [
    {
        id: 1,
        title: "CreativSoft",
        link: "https://www.creativ-soft.com/",
        category: "HTML CSS JavaScript",
    },
    {
        id: 2,
        title: "AprilAire",
        link: "https://www.aprilaire.com/",
        category: "React",
    },
    {
        id: 3,
        title: "Sanford Sports",
        link: "https://www.sanfordsports.com/",
        category: "HTML CSS JavaScript",
    },
    {
        id: 4,
        title: "HireVue",
        link: "https://www.hirevue.com/",
        category: "React",
    },
    {
        id: 5,
        title: "GradThesis",
        link: "https://gradthesis.sciarc.edu/#lexicon",
        category: "Squarespace",
    },
    {
        id: 6,
        title: "UgThesis",
        link: "https://ugthesis.sciarc.edu/",
        category: "Squarespace",
    },
    {
        id: 7,
        title: "Archer Affiliates",
        link: "https://slicing-work.vercel.app/",
        category: "HTML CSS JavaScript",
    },
    {
        id: 8,
        title: "Audax",
        link: "https://audax-lyart.vercel.app/",
        category: "React",
    },
    {
        id: 9,
        title: "The Lancer Group",
        link: "https://lancer-group.vercel.app/",
        category: "React",
    },
    {
        id: 10,
        title: "ChatBot for Charlotte Regional Business Alliance",
        link: "https://charlotteregion.com/",
        category: "HTML CSS JavaScript",
    },
    {
        id: 11,
        title: "Sunflowers",
        link: "https://www.sunflowers.md/",
        category: "React",
    },
    {
        id: 12,
        title: "CasaGrill",
        link: "https://www.casagrill.md/",
        category: "React",
    },
    {
        id: 13,
        title: "Wonderhatch",
        link: "https://wonderhatch.com/",
        category: "HTML CSS JavaScript",
    },
    {
        id: 14,
        title: "AVEVA",
        link: "https://partnergames.aveva.com/",
        category: "React",
    },
];
